import {
  BUTTON_EDIT_MODE,
  RECORD_TYPE,
  ROUTES,
  SPECIAL_FILTER_LABEL,
} from "@lhd/constants";
import { APP_TYPES } from "@lhd/components/CloneApp/constants";
import { isSalaryWorkerFilterChangeSizeRoute } from "@lhd/features/Salary/utils/salaryWorkerFilterRoutes";
import { Divider } from "antd";
import { FC } from "react";
import { useLocation } from "react-router-dom";
import ButtonVerticalCollapse from "../ButtonVerticalCollapse";
import Loading from "../Loading";
import ModalConfirm from "../Modal/ModalConfirm";
import ModalEditConfirm from "../Modal/ModalEditConfirm";
import SelectFilter from "./components/SelectFilter";
import useSearchAreaBox, { Props, ReceivedProps } from "./hook";
import { BottomSection, LoadingWrapper, Styles, TopSection } from "./styled";
import { useGetAuth } from "@lhd/hooks";

const CLONE_APP_SLICER_SCREENS = [
  ROUTES.BUSINESS_RPG,
  ROUTES.BUSINESS_FLOW,
  APP_TYPES.ROLE_PERMISSIONS,
  ROUTES.ROLE_PERMISSIONS,
];

export type CustomFilterConfigs = {
  value: string;
  text: string;
  sort_index?: number;
  selected?: boolean;
  user_id?: number;
  isDefault?: boolean;
  is_hidden?: boolean;
  is_auto_select?: boolean;
  id?: any;
  can_be_deleted?: boolean;
  color?: string;
};

const SearchAreaBoxLayout: FC<Props> = ({
  modalSettingConfig,
  handleCloseModal,
  listDataStatus,
  listDataCategory,
  handleSubmit,
  isSavingCategoryStatusCompanies,
  optionDefaultStatus,
  optionDefaultCategory,
  isCollapse,
  setIsCollapse,
  statusFilterSelected,
  categoryFilterSelected,
  textCategoryField,
  textStatusField,
  disabled,
  disabledClick,
  isLoadingCategoryStatusCompaniesData,
  isFetchingCategoryStatusCompaniesData,
  isCollapseSidebar,
  nonEditable,
  modalConfirm,
  onCancelModalConfirm,
  disabledButtonEdit,
  modalEditConfirm,
  handleChange,
  maintenanceBannerHeight,
  displaySize,
  height,
  openConfirmModal,
  modalResetSignal,
  screen,
  isDisplayInNewTab,
  disableButtonEditMode,
  handleChangeAll,
  showConfigControls,
  hasNullStatusOption,
}) => {
  const location = useLocation();
  const isChangeSize = isSalaryWorkerFilterChangeSizeRoute(location.pathname);
  const { isUserResigned } = useGetAuth();

  return (
    <Styles
      id="container-box-collapse"
      isChangeSize={isChangeSize}
      height={height}
      text_scale={displaySize}
      $isTableList={[ROUTES.BUSINESS_RPG, ROUTES.BUSINESS_FLOW].includes(
        screen as string,
      )}
      $isSidebarCollapsed={isCollapseSidebar}
      $maintenanceBannerHeight={maintenanceBannerHeight}
      $isDisplayInNewTab={isDisplayInNewTab}
    >
      <div
        className={
          "wrapper-search_area_box" +
          (isCollapse ? " box-expend" : " box-collapse") +
          (disabledClick ? " disabled-click" : "")
        }
      >
        {isSavingCategoryStatusCompanies ||
        isLoadingCategoryStatusCompaniesData ? (
          <LoadingWrapper>
            <Loading />
          </LoadingWrapper>
        ) : (
          <>
            {isCollapse && (
              <>
                <TopSection>
                  <div className="section-title">
                    {SPECIAL_FILTER_LABEL.SLICER}
                  </div>
                  <SelectFilter
                    title={SPECIAL_FILTER_LABEL.STATUS}
                    labelButton={SPECIAL_FILTER_LABEL.EDIT_ADD}
                    description={textStatusField}
                    type={RECORD_TYPE.STATUS}
                    selectOptions={listDataStatus}
                    isCollapse={true}
                    setIsCollapse={setIsCollapse}
                    listSelected={statusFilterSelected}
                    handleChange={handleChange}
                    handleChangeAll={handleChangeAll}
                    disabledButtonEdit={
                      disabledButtonEdit ||
                      disableButtonEditMode === BUTTON_EDIT_MODE.STATUS ||
                      disableButtonEditMode === BUTTON_EDIT_MODE.ALL ||
                      isUserResigned
                    }
                    disabled={disabled}
                    displaySize={displaySize}
                    height={height}
                    isChangeSize={isChangeSize}
                    screen={screen}
                    showConfigControls={
                      showConfigControls !== undefined
                        ? showConfigControls
                        : !CLONE_APP_SLICER_SCREENS.includes(screen as string)
                    }
                  />
                </TopSection>
                <Divider />
                <BottomSection>
                  <SelectFilter
                    title={SPECIAL_FILTER_LABEL.CATEGORY}
                    labelButton={SPECIAL_FILTER_LABEL.EDIT_ADD}
                    type={RECORD_TYPE.CATEGORY}
                    description={textCategoryField}
                    selectOptions={listDataCategory}
                    isCollapse={true}
                    setIsCollapse={setIsCollapse}
                    listSelected={categoryFilterSelected}
                    handleChange={handleChange}
                    handleChangeAll={handleChangeAll}
                    disabledButtonEdit={
                      disabledButtonEdit ||
                      disableButtonEditMode === BUTTON_EDIT_MODE.CATEGORY ||
                      disableButtonEditMode === BUTTON_EDIT_MODE.ALL ||
                      isUserResigned
                    }
                    disabled={disabled}
                    displaySize={displaySize}
                    height={height}
                    isChangeSize={isChangeSize}
                    screen={screen}
                    showConfigControls={
                      showConfigControls !== undefined
                        ? showConfigControls
                        : !CLONE_APP_SLICER_SCREENS.includes(screen as string)
                    }
                  />
                </BottomSection>
              </>
            )}
            <div className="collapse-box">
              <ButtonVerticalCollapse
                directionArrow={isCollapse ? "left" : "right"}
                onClick={() => setIsCollapse(!isCollapse)}
                directionRadius="right"
                className="none-set"
                variant={isCollapse ? "danger" : "primary"}
              >
                <div className="vertical-text">スライサー</div>
              </ButtonVerticalCollapse>
            </div>
          </>
        )}
      </div>

      <ModalConfirm
        isOpen={modalConfirm?.isOpen}
        onCancel={onCancelModalConfirm}
        onOk={modalConfirm?.callback}
        content={modalConfirm?.content}
      />

      <ModalEditConfirm
        isOpen={modalEditConfirm?.isOpen}
        onCancel={modalEditConfirm?.onCancel || (() => null)}
        onConfirm={modalEditConfirm?.onConfirm || (() => null)}
        content="現在使用中の値です。変更すると関連データにも更新が反映されます。 更新してよろしいですか？"
        isSubmitting={isSavingCategoryStatusCompanies}
      />
    </Styles>
  );
};

export const SearchAreaBox: FC<ReceivedProps> = (props) => (
  <SearchAreaBoxLayout {...useSearchAreaBox(props)} />
);

export default SearchAreaBox;
